import { useMemo } from 'react'
import { getBackboneWindow } from '@opallabs/brown-dwarf'

export type UserRoleSystemNames =
  | 'admin'
  | 'opal_admin'
  | 'owner'
  | 'publisher'
  | 'user'
  | 'view_only'
  | 'limited'

type UseBackboneUserRole = {
  userRole: UserRoleSystemNames | undefined
  roleIs: (...args: (UserRoleSystemNames | undefined)[]) => boolean
  roleIsNot: (...args: (UserRoleSystemNames | undefined)[]) => boolean
}

export const useBackboneUserRole = (): UseBackboneUserRole => {
  return useMemo(() => {
    const backboneWindow = getBackboneWindow()
    const userRole = backboneWindow?.Opal?.State?.this_user_role
    return {
      userRole,
      roleIs: (...args) => args.includes(userRole),
      roleIsNot: (...args) => !args.includes(userRole),
    }
  }, [])
}
